import StructFunctionality, { forget } from "./StructFunctionality";
const item = 'feed';

export default function FeedStruct ( feed )
{ return StructFunctionality( {}, feed, item ); }

export function forget_feed (  )
{ forget( item ); }
